import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

// Cross-links between MoneyFeed's highest-intent money pages for internal linking / SEO.
const DEFAULT_LINKS = [
  { to: '/whatsapp-accounting', label: 'WhatsApp Accounting' },
  { to: '/ai-bookkeeping', label: 'WhatsApp Expense Capture' },
  { to: '/expense-tracking', label: 'Expense Tracking' },
  { to: '/mileage-tracking', label: 'Mileage Tracking' },
  { to: '/freelancer-bookkeeping', label: 'Freelancer Bookkeeping' },
  { to: '/1099-bookkeeping', label: '1099 Bookkeeping' },
  { to: '/tools/1099-tax-calculator', label: '1099 Tax Calculator' },
  { to: '/receipt-to-excel', label: 'Receipt to Excel' },
  { to: '/scan-receipts-to-pdf', label: 'Receipt to PDF' },
  { to: '/invoice-scanner', label: 'Invoice & Receipt Scanner' },
  { to: '/invoicing', label: 'Invoicing for Freelancers' },
  { to: '/tools/uk-self-assessment-tax-calculator', label: 'UK Self Assessment Calculator' },
  { to: '/blog', label: 'Freelance Tax Blog' },
];

export const RelatedLinks = ({ title = 'Explore more free tools & guides', links = DEFAULT_LINKS, exclude = [] }) => {
  const items = links.filter((l) => !exclude.includes(l.to));
  return (
    <section className="max-w-4xl mx-auto px-4 sm:px-8 py-10" data-testid="related-links">
      <h2 className="text-lg font-bold text-[#064E3B] mb-4 text-center">{title}</h2>
      <div className="flex flex-wrap justify-center gap-2">
        {items.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className="inline-flex items-center gap-1 px-4 py-2 bg-white rounded-full text-sm font-semibold text-[#064E3B] shadow-sm border border-gray-200 hover:border-[#84CC16] transition-colors"
            data-testid={`related-link-${l.to}`}
          >
            {l.label} <ArrowUpRight className="h-3.5 w-3.5 opacity-60" />
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedLinks;
